/**
 * Единая точка входа админки: шаблоны карточек по модулям (вариант B).
 * Вкладка «Объекты» — существующий конструктор без изменения логики.
 */

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CardTemplateManagement from "@/components/admin/CardTemplateManagement";
import RdCardTemplateManagement from "@/components/admin/RdCardTemplateManagement";
import GoCardTemplateManagement from "@/components/admin/GoCardTemplateManagement";
import UdgspzCardTemplateManagement from "@/components/admin/UdgspzCardTemplateManagement";
import VisualizerSignCardTemplateManagement from "@/components/admin/VisualizerSignCardTemplateManagement";
import TacticalFeatureCardTemplateManagement from "@/components/admin/TacticalFeatureCardTemplateManagement";
import { LayoutTemplate, Building2, FileCheck2, Globe2, ShieldEllipsis, Map, Crosshair } from "lucide-react";

export default function CardTemplatesHub() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold tracking-tight flex items-center gap-2">
          <LayoutTemplate className="h-5 w-5" />
          Шаблоны карточек
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Конструкторы по модулям платформы. ОИ — текущие таблицы{" "}
          <code className="text-xs bg-muted px-1 rounded">templates.card_*</code>
          ; РД / ГО / УДГСПЗ — отдельные группы таблиц (
          <code className="text-xs bg-muted px-1 rounded">
            GET /api/v1/admin/card-template-catalog
          </code>
          ).
        </p>
      </div>

      <Tabs defaultValue="oi" className="w-full">
        <TabsList className="flex flex-wrap h-auto gap-1 sm:gap-0">
          <TabsTrigger value="oi" className="gap-1.5">
            <Building2 className="h-4 w-4 shrink-0" />
            Объекты (ОИ)
          </TabsTrigger>
          <TabsTrigger value="rd" className="gap-1.5">
            <FileCheck2 className="h-4 w-4 shrink-0" />
            РД
          </TabsTrigger>
          <TabsTrigger value="go" className="gap-1.5">
            <Globe2 className="h-4 w-4 shrink-0" />
            ГО
          </TabsTrigger>
          <TabsTrigger value="udgspz" className="gap-1.5">
            <ShieldEllipsis className="h-4 w-4 shrink-0" />
            УДГСПЗ
          </TabsTrigger>
          <TabsTrigger value="visualizer" className="gap-1.5">
            <Map className="h-4 w-4 shrink-0" />
            Визуализатор
          </TabsTrigger>
          <TabsTrigger value="tactical" className="gap-1.5">
            <Crosshair className="h-4 w-4 shrink-0" />
            Тактика
          </TabsTrigger>
        </TabsList>

        <TabsContent value="oi" className="mt-4 focus-visible:outline-none">
          <CardTemplateManagement />
        </TabsContent>

        <TabsContent value="rd" className="mt-4 focus-visible:outline-none">
          <RdCardTemplateManagement />
        </TabsContent>

        <TabsContent value="go" className="mt-4 focus-visible:outline-none">
          <GoCardTemplateManagement />
        </TabsContent>

        <TabsContent value="udgspz" className="mt-4 focus-visible:outline-none">
          <UdgspzCardTemplateManagement />
        </TabsContent>

        <TabsContent value="visualizer" className="mt-4 focus-visible:outline-none">
          <VisualizerSignCardTemplateManagement />
        </TabsContent>

        <TabsContent value="tactical" className="mt-4 focus-visible:outline-none">
          <TacticalFeatureCardTemplateManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}
